import { render } from "./StudioList.vue?vue&type=template&id=dfe9de58&scoped=true"
import script from "./StudioList.vue?vue&type=script&lang=js"
export * from "./StudioList.vue?vue&type=script&lang=js"

import "./StudioList.vue?vue&type=style&index=0&id=dfe9de58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfe9de58"]])

export default __exports__